// extracted by mini-css-extract-plugin
export default {"addNewsBox":"addNews_addNewsBox__ugHjZ","imgBox":"addNews_imgBox__4fxRR","langTitle":"addNews_langTitle__1o8Ja"};